import * as d3 from 'd3'

const HEIGHT = 20
const MARGIN = 2

const draw = (config) => selection => {
  let {
    timeScale,
    height,
  } = config

  let axe = selection.selectAll('.axe').data(d => d)

  let ay = d3.axisBottom()
    .scale(timeScale)

  axe.enter()
    .append('g')
    .attr('transform', `translate(0, ${height + MARGIN})`)
    .classed('axe', true)
    .call(ay)

  axe.call(ay)
}

export default {
  draw,
  HEIGHT,
  MARGIN
}